import React from 'react'
import { Box, Typography } from '@mui/material'
import { useReportSearchesModalData } from '@hooks'
import { dsColorNew } from '@palette'
import AppReportSearchesOfficesModalBlock from '@components/ReportSearchesModal/Content/OfficesBlock'
import AppReportSearchesSitesModalBlock from '@components/ReportSearchesModal/Content/SitesBlock'


export default function AppReportSearchesModalContent({ id_report, isRunning, isExtras }) {

	const { sitesData, officesData, areSummariesLoading } = useReportSearchesModalData(id_report, isRunning, isExtras)

	return <>
		<Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 1.75 }}>
			<AppReportSearchesSitesModalBlock isLoading={areSummariesLoading} sitesData={sitesData}/>
			<AppReportSearchesOfficesModalBlock isLoading={areSummariesLoading} officesData={officesData}/>
		</Box>
		{!!isRunning && <Typography sx={{
			mt: 1.75, display: 'inline-flex', alignItems: 'center', gap: 0.75, fontSize: 12, color: dsColorNew.textMuted,
			'&::before': { content: '""', width: 7, height: 7, borderRadius: '50%', backgroundColor: dsColorNew.successBar, boxShadow: `0 0 0 3px ${dsColorNew.successBg}` },
		}}>
			Updates every 5 seconds while it runs
		</Typography>}
	</>
}
